import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	createKeyPersonnel,
	updateKeyPersonnel,
	deleteKeyPersonnel,
	reorderKeyPersonnel,
} from "../key-personnel-api";
import { KEY_PERSONNEL_KEYS } from "./useKeyPersonnel";
import { showToast } from "utils/helpers";
import { useCurrentCompanyId } from "hooks/auth";

export const useCreateKeyPersonnel = () => {
	const queryClient = useQueryClient();
	const companyId = useCurrentCompanyId();
	return useMutation({
		mutationFn: (formData: FormData) => {
			formData.append("company_id", String(companyId));
			return createKeyPersonnel(formData);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: KEY_PERSONNEL_KEYS.all });
			showToast("Created successfully.", "Key Personnel", true);
		},
	});
};

export const useUpdateKeyPersonnel = (id: number) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (formData: FormData) => updateKeyPersonnel(id, formData),
		onSuccess: (data) => {
			queryClient.setQueryData(KEY_PERSONNEL_KEYS.detail(id), data);
		},
	});
};

export const useDeleteKeyPersonnel = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: deleteKeyPersonnel,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: KEY_PERSONNEL_KEYS.all });
			showToast("Record deleted.", "Key Personnel", true);
		},
	});
};

export const useReorderKeyPersonnel = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (args: { id: number; sortOrder: number }) =>
			reorderKeyPersonnel(args.id, args.sortOrder),
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: KEY_PERSONNEL_KEYS.all });
		},
		onSuccess: () => {
			showToast("Order saved.", "Key Personnel", true);
		},
	});
};
